import gql from 'graphql-tag';

export default gql`
  mutation addPassportFideliteSubscriber(
    $email: String
    $withNewsletter: Boolean
  ) {
    addPassportFideliteSubscriber(
      input: { email: $email, withNewsletter: $withNewsletter }
    ) {
      id
      email
    }
  }
`;
